module.exports = __webpack_public_path__ + "img/nogroupdata.4ffab606.svg";